module.exports = __webpack_public_path__ + "static/media/hero-image-desktop@4x.8ac3fa64.jpg";